module.exports = __webpack_public_path__ + "static/img/Group542.edbede95.png";